import * as React from 'react';
import { CouponsItem } from '../../widgets';
import './ReceiveCouponsPopup.less';
import { observer } from 'mobx-react';

interface IReceiveCouponsPropsType {
    prefixCls?: string;
    onHandleClose?: () => void; // 优惠券弹框关闭
    data?: any; // 数据源
    onReceivedCoupons?: (item: any) => void; // 优惠券领取
}

/**
 * 商详页面优惠券领取弹框
 * @class ReceiveCouponsPopup
 * @extends {React.Component<IReceiveCouponsPropsType, any>}
 */
@observer
class ReceiveCouponsPopup extends React.Component<IReceiveCouponsPropsType, any> {
    static defaultProps = {
        prefixCls: 'receive-coupons'
    };

    // 优惠券展示状态
    private static couponsStatusImgBg(receivedStatus: any): string {
        switch (receivedStatus) {
            case 1:
                return '立即领取';
            case 2:
                return '已领取';
            case 3:
                return '已抢光';
            default:
                return '已抢光';
        }
    }

    render() {
        const {prefixCls, onHandleClose, data, onReceivedCoupons} = this.props;
        const coupons = data.coupons || [];
        return (
            <div>
                <div className={`${prefixCls}-cover`}/>
                <div className={`${prefixCls}-container`}>
                    <div className={`${prefixCls}-close`} onClick={onHandleClose}/>
                    <div className={`${prefixCls}-title`}>优惠券</div>
                    {
                        coupons.length > 0 ?
                            <div className={`${prefixCls}-context`}>
                                {
                                    coupons.map((item: any) => {
                                        return (
                                            <CouponsItem
                                                data={item}
                                                text={ReceiveCouponsPopup.couponsStatusImgBg(item.receivedStatus)}
                                                imgBg={ReceiveCouponsPopup.couponsStatusImgBg(item.receivedStatus)}
                                                isShowBg
                                                key={item.templateId}
                                                onHandleClick={() => {onReceivedCoupons && onReceivedCoupons(item)}}
                                                timeType
                                                textWidth='80%'
                                            />
                                        );
                                    })
                                }
                            </div> :
                            <div className={`${prefixCls}-msg`}>抱歉亲，没有可领取优惠券了，下次请赶早哦~</div>
                    }
                </div>
            </div>
        );
    }
}

export default ReceiveCouponsPopup;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/receiveCoupons/ReceiveCouponsPopup.tsx